// extracted by mini-css-extract-plugin
module.exports = {"nav":"SecondaryHeaderNav_nav__XGvqz","open":"SecondaryHeaderNav_open__NsCgF","content":"SecondaryHeaderNav_content__bYIsd"};